/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Create_DescriptionInputs */

const en_admin_posts_create_description = /** @type {(inputs: Admin_Posts_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new blog post`)
};

/**
* | output |
* | --- |
* | "Create a new blog post" |
*
* @param {Admin_Posts_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_create_description = /** @type {((inputs?: Admin_Posts_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_create_description(inputs)
});
export { admin_posts_create_description as "admin.posts.create_description" }